import React from 'react';
import { AlertCircle, Info, AlertTriangle } from 'lucide-react';

interface ErrorObject {
  type?: string;
  message?: string;
  details?: any;
}

interface AuthErrorDisplayProps {
  error?: string | ErrorObject | null;
  type?: 'error' | 'warning' | 'info';
}

const AuthErrorDisplay: React.FC<AuthErrorDisplayProps> = ({
  error,
  type = 'error',
}) => {
  if (!error) return null;

  // Extract error message if it's an object
  const errorMessage = typeof error === 'string' 
    ? error 
    : error?.message || error?.details || 'An error occurred';

  const styles = {
    error: {
      bg: 'bg-red-500/10',
      border: 'border-red-500/20',
      text: 'text-red-400',
      icon: AlertCircle,
    },
    warning: {
      bg: 'bg-yellow-500/10',
      border: 'border-yellow-500/20',
      text: 'text-yellow-400',
      icon: AlertTriangle,
    },
    info: {
      bg: 'bg-blue-500/10',
      border: 'border-blue-500/20',
      text: 'text-blue-400',
      icon: Info,
    },
  };

  const style = styles[type];
  const Icon = style.icon;

  return (
    <div className={`${style.bg} border ${style.border} rounded-2xl p-4 mb-6`}>
      <div className="flex items-center">
        <Icon className={`h-5 w-5 ${style.text} mr-2 flex-shrink-0`} />
        <p className={`text-sm ${style.text}`}>{errorMessage}</p>
      </div>
    </div>
  );
};

export default AuthErrorDisplay;

